import { getMethod, postMethod, putMethod, deleteMethod } from "../../api-service/api-service";
import {
    setBoards,
    setSelectedBoard,
    addBoard,
    updateBoardInList,
    removeBoard,
    setLoading,
    setError,
    setPagination,
} from "./projectBoardSlice";
import { toast } from "react-toastify";

export const fetchBoardsByProjectAction = (projectId, page = 1, limit = 10) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await getMethod(`/project-board/project/${projectId}?page=${page}&limit=${limit}`);

        if (response.success) {
            dispatch(setBoards(response.data || []));
            if (response.pagination) {
                dispatch(setPagination(response.pagination));
            }
            return { success: true, data: response.data };
        } else {
            dispatch(setError(response.message || "Failed to fetch boards"));
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to fetch boards";
        dispatch(setError(message));
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// FETCH BOARD BY ID
export const fetchBoardByIdAction = (id) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await getMethod(`/project-board/details/admin/${id}`);

        if (response.success) {
            dispatch(setSelectedBoard({ ...response.data, boardDisplayPrice: response?.boardDisplayPrice || {} }));
            return { success: true, data: response.data };
        } else {
            dispatch(setError(response.message || "Failed to fetch board"));
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to fetch board";
        dispatch(setError(message));
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// DELETE BOARD
export const deleteBoardAction = (boardId) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await deleteMethod(`/project-board/${boardId}`, {});

        if (response.success) {
            dispatch(removeBoard(boardId));
            toast.success(response.message || "Board deleted successfully");
            return { success: true };
        } else {
            toast.error(response.message || "Failed to delete board");
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to delete board";
        toast.error(message);
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// PERMANENTLY DELETE BOARD
export const permanentlyDeleteBoardAction = (boardId) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await deleteMethod(`/project-board/permanent-delete/${boardId}`, {});

        if (response.success) {
            dispatch(removeBoard(boardId));
            toast.success(response.message || "Board permanently deleted successfully");
            return { success: true };
        } else {
            toast.error(response.message || "Failed to permanently delete board");
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to permanently delete board";
        toast.error(message);
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};

// CLONE BOARD
export const cloneBoardAction = (boardId) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));

        const response = await getMethod(`/project-board/clone/${boardId}`);

        if (response.success) {
            dispatch(addBoard(response.data));
            toast.success(response.message || "Board cloned successfully");
            return { success: true, data: response.data };
        } else {
            toast.error(response.message || "Failed to clone board");
            return { success: false, message: response.message };
        }
    } catch (error) {
        const message = error?.response?.data?.message || "Unable to clone board";
        toast.error(message);
        return { success: false, message };
    } finally {
        dispatch(setLoading(false));
    }
};